import { Stack } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useDrawerSubForm } from 'hooks'
import { useIntl } from 'react-intl'
import { type Restrictions as RestrictionsType } from 'typings'
import { useFormStateContext } from '../../../providers'
import {
  CancelButton,
  DismissButton,
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  SaveButton,
  type UseDrawerStateReturn,
} from '../../Drawer'
import { useRestrictionsContext } from './hooks/useRestrictions.constate'
import { messages } from './messages'
import { RESTRICTIONS } from './typings'
import { validationSuite } from './validation'

type Props = {
  state: UseDrawerStateReturn
}

export function Editor({ state }: Props) {
  const { visibleRestrictions } = useRestrictionsContext()

  const intl = useIntl()

  const { form: mainForm } = useFormStateContext()

  const restrictionsData: RestrictionsType = useWatch({
    form: mainForm,
    name: RESTRICTIONS,
  })

  const { drawerForm } = useDrawerSubForm<RestrictionsType>({
    config: restrictionsData,
    isOpen: state.open,
    validationFn: validationSuite(intl),
  })

  const restrictions = useWatch({ form: mainForm, name: RESTRICTIONS })

  const { $t } = useIntl()

  const handleSave = async () => {
    const isValid = await drawerForm.trigger()
    if (!isValid) return

    const values = drawerForm.getValues()
    mainForm.setValue(RESTRICTIONS, {
      ...restrictions,
      ...values,
    })
    state.hide()
  }

  return (
    <Drawer state={state}>
      <DrawerHeader>
        <DrawerTitle>{$t(messages.editor.title)}</DrawerTitle>
        <DismissButton onHide={state.hide} />
      </DrawerHeader>
      <DrawerContent>
        <Stack space="$space-6">
          {visibleRestrictions.map(({ Element, props }, index) => (
            <Element key={index} {...props} form={drawerForm} />
          ))}
        </Stack>
      </DrawerContent>
      <DrawerFooter>
        <CancelButton onClick={state.hide} />
        <SaveButton onClick={handleSave} />
      </DrawerFooter>
    </Drawer>
  )
}
